import React from 'react';
import SharedComponent from './SharedComponent';

export default () => <SharedComponent page="terms" />;



// WEBPACK FOOTER //
// ./src/views/_InfoServices/Terms.js